/// <reference types="@angular/localize" />

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.console.log = () => { }
}

let script_maps = document.createElement('script');
let url_maps = 'https://maps.googleapis.com/maps/api/js?key={{key}}&libraries=places';
url_maps = url_maps.replace('{{key}}', environment.key_map);
script_maps.src = url_maps;
script_maps.defer = true;
script_maps.async = false;
document.head.appendChild(script_maps);

script_maps.onload = () =>{
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.error(err));
}

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
